// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1sPhy","footer":"ReportModalFilter_footer__1BpTk"};